<script>
import SearchSection from "../package/searchSection.vue";
import ContactUs from "../package/contactUs.vue";
import agentSignInSection from "../package/agentSignInSection.vue";
import discoverMore from "../package/discoverMore.vue";
import SocialSection from "../package/socialSection.vue";
import BuyOffPlanSection from "../package/buyOffPlanSection.vue";
import StayUpToDate from "../package/stayUpToDate.vue";
import AgentsRegistration from "../package/agentsRegistration.vue";
import propertyIconSet from "../package/propertyIconSet.vue";
import FooterSection from "../package/footerSection.vue";
import ConnectingProperties from "../package/connectingProperties.vue";
import TopImageSection from "../package/topImageSection.vue";
import FindOutMore from "../package/findOutMore.vue";
import SearchingImageSection from "./searchingImageSection.vue";
import SearchResultsViewChange from "./searchResultsViewChange.vue";
import SearchResults from "./searchResults.vue";
import AdvertisementOne from "./advertisementOne.vue";
import AdvertisementTwo from "./advertisementTwo.vue";
import AdvertisementThree from "./advertisementThree.vue";
import SimilarProperties from "./similarProperties.vue";
import LoadMore from "./loadMore.vue";
import ViewMore from "./viewMore.vue";
import {
  redirectToContactUs,
  redirectToHome
} from "../../helpers/routerHelper";
import DrawerAside from "../package/DrawerAside.vue";
import HeaderSection from "../package/HeaderSection.vue";

export default {
  name: "SearchLayout",
  data() {
    return {
      unfold: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D"
    };
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
  },
  watch: {
    value1(newValue) {
      let color = newValue ? "#2D2D2D" : "#FFFFFF";
      document.documentElement.style.setProperty("--switch-color", color);
    }
  },
  beforeUpdate() {
    document.title = "UNIFI Property: Search Properties";
  },
  beforeRouteEnter(to, from, next) {
    if (from.name !== "propertyDetailsIndex") {
      next(vm => {
        vm.$refs.$searchResultsRef.loadMore(15);
      });
      return;
    }
    next();
  },
  methods: {
    redirectToHome,
    redirectToContactUs,
    spread() {
      this.unfold = true;
    },
    fold() {
      this.unfold = false;
    },
    triggerSearch() {
      this.$refs.$searchResultsRef.loadMore();
    },
    loadSearch() {
      this.$refs.$searchResultsRef.filterList();
    }
  },
  components: {
    HeaderSection,
    ViewMore,
    LoadMore,
    SimilarProperties,
    AdvertisementThree,
    AdvertisementTwo,
    AdvertisementOne,
    SearchResults,
    SearchResultsViewChange,
    SearchingImageSection,
    FindOutMore,
    TopImageSection,
    ConnectingProperties,
    FooterSection,
    propertyIconSet,
    AgentsRegistration,
    StayUpToDate,
    BuyOffPlanSection,
    SocialSection,
    discoverMore,
    agentSignInSection,
    ContactUs,
    SearchSection,
    DrawerAside
  }
};
</script>

<template>
  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-section @spread="spread" />
      <el-main style="padding: 0; overflow: visible;;margin-top: 6px;">
        <!-- <searching-image-section/> -->
        <search-section />
        <search-results-view-change @loadSearch="loadSearch()" />
        <search-results ref="$searchResultsRef" />
        <!-- <advertisement-one/> -->
        <!-- <search-results/> -->
        <!-- <advertisement-two/> -->
        <!-- <search-results/> -->
        <!-- <advertisement-three/> -->
        <load-more @loadMoreFunction="triggerSearch()" />
        <!-- <similar-properties/> -->
        <!-- <view-more/> -->
        <property-icon-set />
      </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
  </el-container>
</template>

<style scoped>
.mainWrapper {
  background-color: #ffffff;
}

.right-centered {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 16px 16px 0;
}

.left-centered {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 16px 0 16px 16px;
}

.main-menu-item-style {
  padding: 30px 40px;
  background-color: #101010;
  border-bottom: 1px solid #585858;
}

.menu-item-font {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.sub-menu-item-style {
  padding: 0 40px;
  background: #2d2d2d;
}

.sub-item-font {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.centered-social-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.left-centered {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 16px 0 16px 16px;
}

.right-centered {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 16px 20px 0;
}

.light-dark-text {
  color: #dedede;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}

.el-switch /deep/ .el-switch__label--left {
  color: #ffffff;
}

.el-switch /deep/ .el-switch__label--right {
  color: #ffffff;
}

.el-switch /deep/ .el-switch__core:after {
  background-color: var(--switch-color);
}
</style>



// WEBPACK FOOTER //
// src/components/search/searchLayout.vue